module.exports = __webpack_public_path__ + "img/prop-trade-header-bg1.8a99c280.png";